import { LifeBuoy, LogOut, Settings, User } from "lucide-react";

import type { PixatwinSdk } from "@/sdk";

import { CoreTopBarActions } from "./CoreTopBarActions";
import { CoreViewerOverlayControls } from "./CoreViewerOverlayControls";

export const registerCoreUiPlugin = (sdk: PixatwinSdk): void => {
  sdk.extensions.topBar.register({
    id: "core-top-bar-actions",
    component: CoreTopBarActions,
    order: 10,
  });
  sdk.extensions.viewerOverlay.register({
    id: "core-viewer-overlay-controls",
    placement: "top-left",
    component: CoreViewerOverlayControls,
    order: 10,
  });

  sdk.extensions.accountMenu.register({
    id: "profile",
    label: "Profil",
    icon: <User className="mr-2 h-4 w-4" />,
    order: 10,
    onSelect: ({ navigate }) => navigate("/profile"),
  });
  sdk.extensions.accountMenu.register({
    id: "settings",
    label: "Paramètres",
    icon: <Settings className="mr-2 h-4 w-4" />,
    order: 20,
    onSelect: ({ navigate }) => navigate("/settings"),
  });
  sdk.extensions.accountMenu.register({
    id: "support",
    label: "Support",
    icon: <LifeBuoy className="mr-2 h-4 w-4" />,
    order: 30,
    onSelect: () => {
      window.location.href = "mailto:support@pixatwin.ch";
    },
  });
  sdk.extensions.accountMenu.register({
    id: "logout",
    label: "Déconnexion",
    icon: <LogOut className="mr-2 h-4 w-4" />,
    order: 100,
    separatorBefore: true,
    onSelect: ({ logout, navigate }) => {
      logout();
      navigate("/login");
    },
  });
};
